import * as React from "react";
interface props {
  className?: string;
}
const UploadIconSvg = ({ className }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#A8A8A8"
      d="M11.5 15.577v-8.65l-2.33 2.33-.708-.718L12 5l3.539 3.539-.708.719L12.5 6.927v8.65zM5 19v-4.038h1V18h12v-3.038h1V19z"
    ></path>
  </svg>
);

export default UploadIconSvg;
